import { render } from "./CallRoomBackground.vue?vue&type=template&id=aa2752a6&scoped=true"
const script = {}

import "./CallRoomBackground.vue?vue&type=style&index=0&id=aa2752a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2752a6"]])

export default __exports__